const leftDrawerWidth = 240;
export const rightDrawerWidth = 360;
const rightListDrawerWidth = 50;
const rightDrawerMargin = 15;
